import { RestTypeEnum } from '@/types/company-detail';

export const COMPANY_SIZE_0_20 = 'cs_0_20';
export const COMPANY_SIZE_20_99 = 'cs_20_99';
export const COMPANY_SIZE_100_499 = 'cs_100_499';
export const COMPANY_SIZE_500_999 = 'cs_500_999';
export const COMPANY_SIZE_1000_9999 = 'cs_1000_9999';
export const COMPANY_SIZE_10000 = 'cs_10000+';
export const COMPANY_SIZE_MAP: Record<string, string> = {
  [COMPANY_SIZE_0_20]: '20人以下',
  [COMPANY_SIZE_20_99]: '20-99人',
  [COMPANY_SIZE_100_499]: '100-499人',
  [COMPANY_SIZE_500_999]: '500-999人',
  [COMPANY_SIZE_1000_9999]: '1000-9999人',
  [COMPANY_SIZE_10000]: '10000人以上',
};

export const COMPANY_FINANCING_STAGE_UNFINANCED = 'cfs_unfinanced';
export const COMPANY_FINANCING_STAGE_ANGEL = 'cfs_angel';
export const COMPANY_FINANCING_STAGE_A = 'cfs_a';
export const COMPANY_FINANCING_STAGE_B = 'cfs_b';
export const COMPANY_FINANCING_STAGE_C = 'cfs_c';
export const COMPANY_FINANCING_STAGE_D = 'cfs_d+';
export const COMPANY_FINANCING_STAGE_NO_NEED = 'cfs_no_need';
export const COMPANY_FINANCING_STAGE_LISTED = 'cfs_listed';

export const COMPANY_FINANCING_STAGE_MAP: Record<string, string> = {
  [COMPANY_FINANCING_STAGE_UNFINANCED]: '未融资',
  [COMPANY_FINANCING_STAGE_ANGEL]: '天使轮',
  [COMPANY_FINANCING_STAGE_A]: 'A轮',
  [COMPANY_FINANCING_STAGE_B]: 'B轮',
  [COMPANY_FINANCING_STAGE_C]: 'C轮',
  [COMPANY_FINANCING_STAGE_D]: 'D轮及以上',
  [COMPANY_FINANCING_STAGE_NO_NEED]: '不需要融资',
  [COMPANY_FINANCING_STAGE_LISTED]: '已上市',
};

export const AGE_MAP: Record<string, string> = {
  GENERATION_70: '70后',
  GENERATION_80: '80后',
  GENERATION_85: '85后',
  GENERATION_90: '90后',
  GENERATION_95: '95后',
  GENERATION_00: '00后',
};

export const REST_TYPE_MAP: Record<string, string> = {
  [RestTypeEnum.Double]: '周末双休',
  [RestTypeEnum.Single]: '周末单休',
  [RestTypeEnum.BigSmall]: '大小周',
  [RestTypeEnum.Shift]: '轮班制',
};

export const WORK_OVERTIME_TYPE_MAP: Record<string, string> = {
  never: '不加班',
  occasionally: '偶尔加班',
  paid: '有偿加班',
};

export const ACTIVE_TABS = [
  { en: 'panorama', title: '全景分析' },
  { en: 'opportunities-and-challenges', title: '机遇与挑战' },
  { en: 'culture', title: '团队文化' },
  { en: 'job-seeking-guide', title: '求职指南' },
  { en: 'hot-jobs', title: '热招岗位' },
];
